<template>
  <div :class="$setClasses">
    <nxt-core-tooltip :content="content"
                 :not-disabled-tooltip="!!content"
                 placement="top-start"
                 popper-class="rating-icon">
      <img :alt="alt"
           :class="$vClass('image')"
           :src="src"
           height="48"
           width="48">
    </nxt-core-tooltip>
  </div>
</template>

<script>
export default {
  name: 'OfferRatingIcon',
  nameClassStyle: 'offer-rating-icon',
  props: {
    rating: {
      type: Number,
      default: 0,
    },
    count: {
      type: Number,
      default: 0,
    },
    alt: String,
    src: String,
    content: String,
  },
};
</script>

<style scoped lang="scss">
.offer-rating-icon {
  width: 48px;
  display: flex;

  &__image {
    object-fit: cover;
  }

  :deep(.tooltip) {
    height: 48px;
  }
}
</style>
